import { toCategories, toCategory } from '../serializers'
import { Checkbox, AddOptions } from 'components/ideal-core-ui'
import s from '../Opportunity.scss'

const Fields = ({ details, setOrganizationDetails }) => {
  return (
    <>
      <AddOptions
        texts={{
          title: 'Opportunity Category',
          subtitle: 'Category Options',
          description:
            'Opportunity category holds information about the type of buildings you are bidding. It helps you differentiate between the different types of buildings you work on over time and also your winning rate and client information based on building type. You can add or remove opportunity categories in this section.'
        }}
        url="/v1/dealcategory"
        toItemSerializer={toCategory}
        toItemsSerializer={toCategories}
        cy="opportunity_category"
      />
      <AddOptions
        texts={{
          title: 'Opportunity Client Bid Stage',
          subtitle: 'Client Bid Stage Options',
          description:
            'Depending on who your clients are, they may have different bid stages. Please set these options here. Note that Bidding and Bidding Awarded cannot be deleted because there is system automation related to them.'
        }}
        url="/v1/deal-bid-status"
        toItemSerializer={toCategory}
        toItemsSerializer={toCategories}
      />
      <AddOptions
        texts={{
          title: 'Opportunity Internal Bid Status',
          subtitle: 'Internal Bid Status Options',
          description:
            'Internal bid status is used to track the internal status of the opportunity. You can add or remove internal bid status options in this section.'
        }}
        url="/v1/deal-internal-bid-status"
        toItemSerializer={toCategory}
        toItemsSerializer={toCategories}
      />
      <AddOptions
        texts={{
          title: 'Opportunity Scope(s)',
          subtitle: 'Scope Options',
          description:
            'If your company offers multiple services and you`d like to track these per opportunity, please set the options here.'
        }}
        url="/v1/deal-scope"
        toItemSerializer={toCategory}
        toItemsSerializer={toCategories}
      />
      <AddOptions
        texts={{
          title: 'Opportunity Geographical Area',
          subtitle: 'Geographical Area Options',
          description:
            'Opportunity geographical area can help you report on revenue or forecast for a specific area.'
        }}
        url="/v1/geographical-area"
        toItemSerializer={toCategory}
        toItemsSerializer={toCategories}
        cy="opportunity_geographical_area"
      />
      <AddOptions
        texts={{
          title: 'Opportunity Source',
          subtitle: 'Source Options',
          description:
            'Opportunity source helps marketing and sales departments identify the most successful channels. You can add or remove opportunity sources in this section.'
        }}
        url="/v1/dealsource"
        toItemSerializer={toCategory}
        toItemsSerializer={toCategories}
        cy="opportunity_source"
      />
      <AddOptions
        texts={{
          title: 'Reason for Not Bidding an Opportunity',
          subtitle: 'Reason for Not Bidding Options',
          description:
            'The reasons for not bidding an opportunity will help you isolate any challanges or shortages you might have in your sales process.'
        }}
        url="/v1/deal-notbidding-reason"
        toItemSerializer={toCategory}
        toItemsSerializer={toCategories}
        cy="opportunity_not_bidding_reasons"
      />
      <AddOptions
        texts={{
          title: 'Reason for Not Winning an Opportunity',
          subtitle: 'Reason for Not Winning',
          description:
            'The reasons for not winning an opportunity will help you isolate any challanges you might have in your sales process and also identify opportunities to increase your closing ratio.'
        }}
        url="/v1/dealreason"
        toItemSerializer={toCategory}
        toItemsSerializer={toCategories}
        cy="opportunity_reasons"
      />
      <AddOptions
        texts={{
          title: 'Opportunity Work Type',
          subtitle: 'Options for Work Type'
        }}
        url="/v1/deal-work-type"
        toItemSerializer={toCategory}
        toItemsSerializer={toCategories}
      />
      <AddOptions
        texts={{
          title: 'Opportunity Contract Type',
          subtitle: 'Options for Contract Type',
          description: ''
        }}
        url="/v1/deal-contract-type"
        toItemSerializer={toCategory}
        toItemsSerializer={toCategories}
        cy="opportunity_contract_types"
      />
      <AddOptions
        texts={{
          title: 'Project Status Field on Opportunity Page',
          subtitle: 'Options for Proiect Status',
          description: ''
        }}
        url="/v1/deal-project-status"
        toItemSerializer={toCategory}
        toItemsSerializer={toCategories}
      />
      <div className={s.settingsItem}>
        <h5 style={{ marginRight: '15px', display: 'inline-block' }}>
          Show project status label on the Opportunities board cards
        </h5>
        <Checkbox
          size="md"
          isChecked={details.dealSettings?.showProjectStatus}
          triggerCheckbox={value => {
            setOrganizationDetails(state => {
              state.dealSettings.showProjectStatus = value.target.checked
            })
          }}
        />
      </div>
      <div className={s.settingsItem}>
        <h5 style={{ marginRight: '15px', display: 'inline-block' }}>
          Check opportunity health automatically
        </h5>
        <Checkbox
          size="md"
          isChecked={details.dealSettings?.checkOpportunityHealth}
          triggerCheckbox={value => {
            setOrganizationDetails(state => {
              state.dealSettings.checkOpportunityHealth = value.target.checked
            })
          }}
        />
        <p>
          When this option is selected, the system automatically checks the health of all your
          opportunities at 12:01 AM (based on organization time zone). If the Bid Due Date,
          Follow-up Date, or opportunity tasks are overdue, the opportunity health is turned from On
          Track to Slipping.
          <br />
          <br />
          Also, if an opportunity that was Slipping before now has Bid Due Date, Follow-up Date, or
          the Task due dates in the future, than the opportunity health will switch back from
          Slipping to On Track.
        </p>
      </div>
      <div className={s.settingsItem}>
        <h5 style={{ marginRight: '15px', display: 'inline-block' }}>
          Opportunity health manual override
        </h5>
        <Checkbox
          size="md"
          isChecked={details.dealSettings?.opportunityHealthManualOverride}
          triggerCheckbox={value => {
            setOrganizationDetails(state => {
              state.dealSettings.opportunityHealthManualOverride = value.target.checked
            })
          }}
        />
        <p>When this option is selected users can change the opportunity health manually.</p>
      </div>
      <div className={s.settingsItem}>
        <h5 style={{ marginRight: '15px', display: 'inline-block' }}>
          Show option to set &quot;Is Opportunity Public/Private?&quot; on each page.
        </h5>
        <Checkbox
          size="md"
          isChecked={details.dealSettings?.showPublicPrivate}
          triggerCheckbox={value => {
            setOrganizationDetails(state => {
              state.dealSettings.showPublicPrivate = value.target.checked
            })
          }}
        />
        <p>When this option is selected users can set the opportunity to Public or Private.</p>
      </div>
      <div className={s.settingsItem}>
        <h5 style={{ marginRight: '15px', display: 'inline-block' }}>
          Show option to set &quot;Were you invited to bid; Yes/No&quot; on each opportunity page.
        </h5>
        <Checkbox
          size="md"
          isChecked={details.dealSettings?.showInvitedToBid}
          triggerCheckbox={value => {
            setOrganizationDetails(state => {
              state.dealSettings.showInvitedToBid = value.target.checked
            })
          }}
        />
        <p>
          When this option is seected a field shows next to each client so users can select whether
          you were invited to bid obv that client or not
        </p>
      </div>
    </>
  )
}

export default Fields
